import { parentUrl } from '../../App/App.config'
import pushGTMEvent from '../../util/helper/pushGTMEvent'

const configContents = ({
  auth: { loginWithRedirect },
  state: { langStrings, user },
}) => {
  const {
    reviewAccountInfo: {
      differentAccount,
      emailConfirm,
      pageTitle,
      signedInAs,
    } = {},
    signIn: { signInHelp } = {},
  } = langStrings || {}

  const handleSignIn = () => {
    loginWithRedirect({
      appState: {
        returnTo: parentUrl,
      },
      prompt: 'login',
      redirectMethod: 'replace', // needed to avoid window.parent.history write error
      redirectTarget: window.parent.location,
    })
  }

  return [
    {
      isTitle: true,
      hasLargeBottom: true,
      description: pageTitle || '1. Review your account information',
    },
    {
      description: signedInAs || 'You are signed in as:',
      style: { fontWeight: 'bold' },
    },
    {
      description: `${user.firstName} ${user.lastName}`,
      style: { fontWeight: 'bold' },
    },
    {
      description: user.email,
      style: { fontWeight: 'bold' },
      paragraphStyle: { marginBottom: '40px' },
    },
    {
      description:
        emailConfirm ||
        'We will use this email to pull up your account and send you a confirmation.',
      paragraphStyle: { marginBottom: '30px' },
    },
    {
      description: differentAccount || '<a>Sign into a different account<a/>',
      paragraphStyle: { marginBottom: '12px' },
      handleTextClick: handleSignIn,
    },
    {
      description:
        signInHelp ||
        '<a target="_blank" href="https://knowledge.autodesk.com/contact-support/account-management/account-creation-sign-profile-management">Having trouble signing in?</a>',
    },
  ]
}

const configFooter = ({
  auth: { isAuthenticated },
  state: { hasExtension },
  dispatch,
}) => ({
  // requiredDisclaimer: true,
  // hasQuestion: true,
  hasExtension,
  handleBack: () => dispatch({ type: 'GO_TO_WELCOME_PAGE' }),
  hideNextButton: !isAuthenticated,
  handleNext: () => {
    pushGTMEvent('ProductInfo')
    dispatch({ type: 'GO_TO_PRODUCT_INFO_PAGE' })
  },
})

export default {
  configContents,
  configFooter,
}
